import type { CustomerImportCommitStatus } from "../../../../../../../api/kehrblatt/imports"

type ProgressStatus = Pick<
  CustomerImportCommitStatus,
  "status" | "phase" | "processed_records" | "total_records"
>

/** Row completion is not transaction completion. Never invent progress during finalization. */
export const customerImportStatusPresentation = (status: ProgressStatus) => {
  const total = Math.max(status.total_records ?? 0, 0)
  const processed = Math.max(status.processed_records ?? 0, 0)
  const count = (value: number) => value.toLocaleString("de-DE")
  const terminal = [
    "finished_successful",
    "finished_with_warnings",
    "finished_with_error",
    "manual_action_required",
    "expired",
  ].includes(status.status)
  const successful = ["finished_successful", "finished_with_warnings"].includes(status.status)
  const retrying = status.status === "retrying"
  const finishing =
    !terminal && !retrying && ["post_processing", "finalizing"].includes(status.phase)
  const label = retrying
    ? "Import wird erneut versucht …"
    : finishing
      ? `Alle ${count(total)} Datensätze verarbeitet. Import wird abgeschlossen …`
      : terminal
        ? successful
          ? status.status === "finished_with_warnings"
            ? "Import mit Hinweisen abgeschlossen."
            : "Import erfolgreich abgeschlossen."
          : "Import nicht erfolgreich abgeschlossen. Bitte Status prüfen."
        : total > 0
          ? `${count(processed)} von ${count(total)} Datensätzen`
          : "Import wird vorbereitet …"

  return {
    total,
    processed,
    label,
    terminal,
    successful,
    finishing,
    indeterminate: !terminal && (finishing || retrying || total === 0),
    percent: total > 0 ? Math.round((Math.min(processed, total) / total) * 100) : 0,
  }
}
